<template>
  <Panel name="محصولات" class="mt-10">
    <form action="">
      <Select class="text-sm" v-model="hasProducts">
        <option value="" selected disabled>حضور محصولات تبرک درفروشگاه</option>
        <option value="true">بلی</option>
        <option value="false">خیر</option>
      </Select>

      <!-- <Select v-model="productNotPresentReason" v-if="hasProducts === 'false'">
        <option value="" selected disabled>علت</option>
        <option value="true">عدم حضور ویزیتور</option>
        <option value="false">عدم آشنایی با سبد کالا</option>
      </Select>

      <div v-if="hasProducts === 'true'">
        <Select
          class="text-sm"
          v-for="question in questions"
          :key="question"
          v-model="question.score"
        >
          <option value="" selected disabled>{{ question.question }}</option>
          <option value="1">ضعیف</option>
          <option value="2">متوسط</option>
          <option value="3">خوب</option>
          <option value="4">خیلی خوب</option>
          <option value="5">عالی</option>
        </Select>
      </div> -->
      <Select
        class="text-sm"
        v-for="question in surveyQuestions"
        :key="question"
        v-model="question.score"
      >
        <option value="" selected disabled>{{ question.question }}</option>
        <option
          v-for="(name, index) in question.options"
          :key="index"
          :value="index"
        >
          {{ name.name }}
        </option>
      </Select>
      <router-link to="/survey/questionnaire">
        <Button class="w-full mt-4" @click="submitProductSurvey">ادامه</Button>
      </router-link>
      <transition name="fade">
        <div
          class="fixed flex justify-center w-full h-screen top-0 bg-gray-500 bg-opacity-60"
          v-if="quesModal"
          @click="quesModal = false"
        >
          <div
            class="bg-white shadow w-3/4 h-3/4 rounded-lg p-4 mt-10 overflow-scroll"
            @click.stop
          >
            <form action="" @submit.prevent="submitAnswers()">
              <Button class="w-full mt-5" type="submit">ثبت</Button>
            </form>
          </div>
        </div>
      </transition>
    </form>
  </Panel>
</template>

<script>
import Panel from "../../components/Panel";
import Select from "../../components/Select";
import questions from "../../data/questions";
import Button from "../../components/Button";
import surveyQuestions from "../../data/surveyQuestions";

export default {
  name: "ProductSurvey",
  components: { Button, Select, Panel },
  data() {
    return {
      hasProducts: this.$store.state.survey.productSurvey.hasProducts,
      productNotPresentReason:
        this.$store.state.survey.productSurvey.productNotPresentReason,
      questions: this.$store.state.survey.productSurvey.questions || questions,
      surveyQuestions: surveyQuestions,
      quesModal: false,
    };
  },
  methods: {
    submitProductSurvey() {
      let vm = this;
      const productSurvey = {
        hasProducts: vm.hasProducts,
        productNotPresentReason: vm.productNotPresentReason,
        surveyQuestions: vm.surveyQuestions,
      };
      this.$store.dispatch("setProductSurvey", productSurvey);
    },
  },
};
</script>

<style scoped></style>
